import { meses_ano } from "./valores_estaticos"

export const date_in_string_to_format_layout = (data_original: string) => {


    let data_format = new Date(data_original)
    let dia = data_format.getDay()
    let mes = meses_ano[data_format.getMonth()]
    let ano = data_format.getFullYear()
    let hora = data_format.getHours()
    let aux_minutos = data_format.getMinutes()
    let minutos = aux_minutos.toString().length === 1 ? '0' + aux_minutos : aux_minutos
 
    let string_to_return = dia + ' de ' + mes + ' de ' + ano + ' às ' + hora + ':' + minutos + 'h'
    return string_to_return
  }
